import React, { useState } from 'react'
import TaskCard from './TaskCard'
import AgentProfile from './AgentProfile'
import AgentActivity from './AgentActivity'
import { useNavigate, useParams } from 'react-router-dom'
import { PieChartAgent } from './PieChartAgent'
import SpeedMeter from './SpeedMeter'
import ResponseCard from './ResponseCard'

const DashboardIndex = () => {
  const [selectedDate, setSelectedDate] = useState<any>('Daily')
  const params = useParams()
  const uuid: any = Number(params.uuid)
  const naviagte = useNavigate()

  const handleChange = (event: any) => {
    setSelectedDate(event.target.value)
  }

  const Data = {
    Daily: {
      totalNumberOfAgent: '5',
      productivity: '84.17%',
      totalHandleTimeHoursAllAgent: '29.47',
      averageConversationsPerHourByAllAgent: '3.58',
      chatStatus: {
        totalConversationByAllAgent: 120,
        totalConversationsResolvedByAllAgent: 101,
        totalConversationsEscalatedByAllAgent: 19
      },
      agentsListing: [
        {
          agentId: '1',
          status: 'ACTIVE',
          name: 'Beauty Singh​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(3).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'be********h@kia******.com',
          mobile: '96******78',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:10:00',
          averageConversationsPerHour: 3,
          totalConversations: 24,
          totalConversationsResolved: 19,
          resolutionPercentage: '79.17%',
          averageHandleTimeSec: 900,
          totalConversationsEscalated: 5,
          avgFirstResponseTimeSec: 20,
          totalHandleTimeHours: 6.0,
          totalHandleTimeMins: 360.0,
          avgResolutionTimeMins: 18.95,
          customerFeedbackRating: 4.5,
          occupancyGoal: '70%',
          occupancyPercentage: '94%'
        },
        {
          agentId: '2',
          status: 'INACTIVE',
          name: 'Keshav Sharma',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(4).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****2',
          email: 'ke*********a@kia******.com',
          mobile: '92******79',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '09:12:00',
          averageConversationsPerHour: 4,
          totalConversations: 32,
          totalConversationsResolved: 29,
          resolutionPercentage: '90.63%',
          averageHandleTimeSec: 660,
          totalConversationsEscalated: 3,
          avgFirstResponseTimeSec: 25,
          totalHandleTimeHours: 5.87,
          totalHandleTimeMins: 352.0,
          avgResolutionTimeMins: 12.14,
          customerFeedbackRating: 4.2,
          occupancyGoal: '70%',
          occupancyPercentage: '92%'
        },
        {
          agentId: '3',
          status: 'ACTIVE',
          name: 'Ritik Saini​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(5).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'ri*******i@kia******.com',
          mobile: '88******80',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:17:00',
          averageConversationsPerHour: 4,
          totalConversations: 32,
          totalConversationsResolved: 28,
          resolutionPercentage: '87.50%',
          averageHandleTimeSec: 720,
          totalConversationsEscalated: 4,
          avgFirstResponseTimeSec: 22,
          totalHandleTimeHours: 6.4,
          totalHandleTimeMins: 384.0,
          avgResolutionTimeMins: 13.71,
          customerFeedbackRating: 4.7,
          occupancyGoal: '70%',
          occupancyPercentage: '100%'
        },
        {
          agentId: '4',
          status: 'INACTIVE',
          name: 'Ankit Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(1).png',
          agentLevel: 'L2',
          employeeId: 'EMP2****4',
          email: 'an********a@kia******.com',
          mobile: '96******81',
          skillset: 'L2',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:23:00',
          averageConversationsPerHour: 2,
          totalConversations: 16,
          totalConversationsResolved: 13,
          resolutionPercentage: '81.25%',
          averageHandleTimeSec: 1320,
          totalConversationsEscalated: 3,
          avgFirstResponseTimeSec: 18,
          totalHandleTimeHours: 5.87,
          totalHandleTimeMins: 352.0,
          avgResolutionTimeMins: 27.08,
          customerFeedbackRating: 4.3,
          occupancyGoal: '70%',
          occupancyPercentage: '92%'
        },
        {
          agentId: '5',
          status: 'ACTIVE',
          name: 'Avinash Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(2).png',
          agentLevel: 'L3',
          employeeId: 'EMP2****5',
          email: 'av**********a@kia******.com',
          mobile: '93******82',
          skillset: 'L3',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:41:00',
          averageConversationsPerHour: 2,
          totalConversations: 16,
          totalConversationsResolved: 12,
          resolutionPercentage: '75.00%',
          averageHandleTimeSec: 1200,
          totalConversationsEscalated: 4,
          avgFirstResponseTimeSec: 15,
          totalHandleTimeHours: 5.33,
          totalHandleTimeMins: 320.0,
          avgResolutionTimeMins: 26.67,
          customerFeedbackRating: 4.4,
          occupancyGoal: '70%',
          occupancyPercentage: '83%'
        }
      ]
    },
    Weekly: {
      totalNumberOfAgent: '5',
      productivity: '91.84%',
      averageConversationsPerHourByAllAgent: '7.79',
      chatStatus: {
        totalConversationByAllAgent: 331,
        totalConversationsResolvedByAllAgent: 304,
        totalConversationsEscalatedByAllAgent: 27
      },
      agentsListing: [
        {
          agentId: '1',
          status: 'ACTIVE',
          name: 'Beauty Singh​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(3).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'be********h@kia******.com',
          mobile: '96******78',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:10:00',
          averageConversationsPerHour: 3,
          totalConversations: 100,
          totalConversationsResolved: 90,
          resolutionPercentage: '90.00%',
          averageHandleTimeSec: 900,
          totalConversationsEscalated: 10,
          avgFirstResponseTimeSec: 23,
          totalHandleTimeHours: 25.0,
          totalHandleTimeMins: 1500.0,
          avgResolutionTimeMins: 16.67,
          customerFeedbackRating: 4.5
        },
        {
          agentId: '2',
          status: 'INACTIVE',
          name: 'Keshav Sharma',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(4).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****2',
          email: 'ke*********a@kia******.com',
          mobile: '92******79',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:20:00',
          averageConversationsPerHour: 2,
          totalConversations: 92,
          totalConversationsResolved: 85,
          resolutionPercentage: '92.39%',
          averageHandleTimeSec: 660,
          totalConversationsEscalated: 7,
          avgFirstResponseTimeSec: 17,
          totalHandleTimeHours: 16.87,
          totalHandleTimeMins: 1012.0,
          avgResolutionTimeMins: 11.91,
          customerFeedbackRating: 4.2
        },
        {
          agentId: '3',
          status: 'ACTIVE',
          name: 'Ritik Saini​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(5).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'ri*******i@kia******.com',
          mobile: '88******80',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:18:00',
          averageConversationsPerHour: 3,
          totalConversations: 112,
          totalConversationsResolved: 105,
          resolutionPercentage: '93.75%',
          averageHandleTimeSec: 720,
          totalConversationsEscalated: 7,
          avgFirstResponseTimeSec: 18,
          totalHandleTimeHours: 22.4,
          totalHandleTimeMins: 1344.0,
          avgResolutionTimeMins: 12.8,
          customerFeedbackRating: 4.7
        },
        {
          agentId: '4',
          status: 'INACTIVE',
          name: 'Ankit Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(1).png',
          agentLevel: 'L2',
          employeeId: 'EMP2****4',
          email: 'an********a@kia******.com',
          mobile: '96******81',
          skillset: 'L2',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:40:00',
          averageConversationsPerHour: 3,
          totalConversations: 24,
          totalConversationsResolved: 21,
          resolutionPercentage: '87.50%',
          averageHandleTimeSec: 1320,
          totalConversationsEscalated: 3,
          avgFirstResponseTimeSec: 10,
          totalHandleTimeHours: 8.8,
          totalHandleTimeMins: 528.0,
          avgResolutionTimeMins: 25.14,
          customerFeedbackRating: 4.3
        },
        {
          agentId: '5',
          status: 'ACTIVE',
          name: 'Avinash Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(2).png',
          agentLevel: 'L3',
          employeeId: 'EMP2****5',
          email: 'av**********a@kia******.com',
          mobile: '93******82',
          skillset: 'L3',
          loginHourGoal: '08:00:00',
          actualLoginHour: '09:00:00',
          averageConversationsPerHour: 2,
          totalConversations: 3,
          totalConversationsResolved: 3,
          resolutionPercentage: '100.00%',
          averageHandleTimeSec: 1200,
          totalConversationsEscalated: 0,
          avgFirstResponseTimeSec: 12,
          totalHandleTimeHours: 1.0,
          totalHandleTimeMins: 60.0,
          avgResolutionTimeMins: 20.0,
          customerFeedbackRating: 4.4
        }
      ]
    },
    Monthly: {
      totalNumberOfAgent: '5',
      productivity: '91.57%',
      averageConversationsPerHourByAllAgent: '31.02',
      chatStatus: {
        totalConversationByAllAgent: 1328,
        totalConversationsResolvedByAllAgent: 1216,
        totalConversationsEscalatedByAllAgent: 112
      },
      agentsListing: [
        {
          agentId: '1',
          status: 'ACTIVE',
          name: 'Beauty Singh​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(3).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'be********h@kia******.com',
          mobile: '96******78',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:15:00',
          averageConversationsPerHour: 3,
          totalConversations: 400,
          totalConversationsResolved: 350,
          resolutionPercentage: '87.50%',
          averageHandleTimeSec: 900,
          totalConversationsEscalated: 50,
          avgFirstResponseTimeSec: 11,
          totalHandleTimeHours: 100.0,
          totalHandleTimeMins: 6000.0,
          avgResolutionTimeMins: 17.14,
          customerFeedbackRating: 4.1
        },
        {
          agentId: '2',
          status: 'INACTIVE',
          name: 'Keshav Sharma',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(4).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****2',
          email: 'ke*********a@kia******.com',
          mobile: '92******79',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:25:00',
          averageConversationsPerHour: 2,
          totalConversations: 368,
          totalConversationsResolved: 340,
          resolutionPercentage: '92.39%',
          averageHandleTimeSec: 660,
          totalConversationsEscalated: 28,
          avgFirstResponseTimeSec: 15,
          totalHandleTimeHours: 67.47,
          totalHandleTimeMins: 4048.0,
          avgResolutionTimeMins: 11.91,
          customerFeedbackRating: 4.2
        },
        {
          agentId: '3',
          status: 'ACTIVE',
          name: 'Ritik Saini​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(5).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'ri*******i@kia******.com',
          mobile: '88******80',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:18:00',
          averageConversationsPerHour: 3,
          totalConversations: 448,
          totalConversationsResolved: 420,
          resolutionPercentage: '93.75%',
          averageHandleTimeSec: 720,
          totalConversationsEscalated: 28,
          avgFirstResponseTimeSec: 18,
          totalHandleTimeHours: 89.6,
          totalHandleTimeMins: 5376.0,
          avgResolutionTimeMins: 12.8,
          customerFeedbackRating: 4.7
        },
        {
          agentId: '4',
          status: 'INACTIVE',
          name: 'Ankit Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(1).png',
          agentLevel: 'L2',
          employeeId: 'EMP2****4',
          email: 'an********a@kia******.com',
          mobile: '96******81',
          skillset: 'L2',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:45:00',
          averageConversationsPerHour: 3,
          totalConversations: 106,
          totalConversationsResolved: 100,
          resolutionPercentage: '94.34%',
          averageHandleTimeSec: 1320,
          totalConversationsEscalated: 6,
          avgFirstResponseTimeSec: 25,
          totalHandleTimeHours: 38.87,
          totalHandleTimeMins: 2332.0,
          avgResolutionTimeMins: 23.32,
          customerFeedbackRating: 4.3
        },
        {
          agentId: '5',
          status: 'ACTIVE',
          name: 'Avinash Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(2).png',
          agentLevel: 'L3',
          employeeId: 'EMP2****5',
          email: 'av**********a@kia******.com',
          mobile: '93******82',
          skillset: 'L3',
          loginHourGoal: '08:00:00',
          actualLoginHour: '09:05:00',
          averageConversationsPerHour: 2,
          totalConversations: 6,
          totalConversationsResolved: 6,
          resolutionPercentage: '100.00%',
          averageHandleTimeSec: 1200,
          totalConversationsEscalated: 0,
          avgFirstResponseTimeSec: 22,
          totalHandleTimeHours: 2.0,
          totalHandleTimeMins: 120.0,
          avgResolutionTimeMins: 20.0,
          customerFeedbackRating: 4.4
        }
      ]
    },

    Quarterly: {
      totalNumberOfAgent: '5',
      productivity: '91.58%',
      averageConversationsPerHourByAllAgent: '94.8',
      chatStatus: {
        totalConversationByAllAgent: 3984,
        totalConversationsResolvedByAllAgent: 3648,
        totalConversationsEscalatedByAllAgent: 336
      },
      agentsListing: [
        {
          agentId: '1',
          status: 'ACTIVE',
          name: 'Beauty Singh​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(3).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'be********h@kia******.com',
          mobile: '96******78',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:30:00',
          averageConversationsPerHour: 3,
          totalConversations: 1200,
          totalConversationsResolved: 1050,
          resolutionPercentage: '87.50%',
          averageHandleTimeSec: 900,
          totalConversationsEscalated: 150,
          avgFirstResponseTimeSec: 18,
          totalHandleTimeHours: 300.0,
          totalHandleTimeMins: 18000.0,
          avgResolutionTimeMins: 17.14,
          customerFeedbackRating: 4.1
        },
        {
          agentId: '2',
          status: 'INACTIVE',
          name: 'Keshav Sharma',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(4).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****2',
          email: 'ke*********a@kia******.com',
          mobile: '92******79',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:38:00',
          averageConversationsPerHour: 2,
          totalConversations: 1104,
          totalConversationsResolved: 1020,
          resolutionPercentage: '92.39%',
          averageHandleTimeSec: 660,
          totalConversationsEscalated: 84,
          avgFirstResponseTimeSec: 20,
          totalHandleTimeHours: 202.4,
          totalHandleTimeMins: 12144.0,
          avgResolutionTimeMins: 11.91,
          customerFeedbackRating: 4.2
        },
        {
          agentId: '3',
          status: 'ACTIVE',
          name: 'Ritik Saini​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(5).png',
          agentLevel: 'L1',
          employeeId: 'EMP2****3',
          email: 'ri*******i@kia******.com',
          mobile: '88******80',
          skillset: 'L1',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:52:00',
          averageConversationsPerHour: 4,
          totalConversations: 1344,
          totalConversationsResolved: 1260,
          resolutionPercentage: '93.75%',
          averageHandleTimeSec: 720,
          totalConversationsEscalated: 84,
          avgFirstResponseTimeSec: 12,
          totalHandleTimeHours: 268.8,
          totalHandleTimeMins: 16128.0,
          avgResolutionTimeMins: 12.8,
          customerFeedbackRating: 4.7
        },
        {
          agentId: '4',
          status: 'INACTIVE',
          name: 'Ankit Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(1).png',
          agentLevel: 'L2',
          employeeId: 'EMP2****4',
          email: 'an********a@kia******.com',
          mobile: '96******81',
          skillset: 'L2',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:02:00',
          averageConversationsPerHour: 3,
          totalConversations: 318,
          totalConversationsResolved: 300,
          resolutionPercentage: '94.34%',
          averageHandleTimeSec: 1320,
          totalConversationsEscalated: 18,
          avgFirstResponseTimeSec: 22,
          totalHandleTimeHours: 116.6,
          totalHandleTimeMins: 6996.0,
          avgResolutionTimeMins: 23.32,
          customerFeedbackRating: 4.3
        },
        {
          agentId: '5',
          status: 'ACTIVE',
          name: 'Avinash Sharma​',
          image: 'https://botgobucket.s3.ap-south-1.amazonaws.com/kia_image/image+(2).png',
          agentLevel: 'L3',
          employeeId: 'EMP2****5',
          email: 'av**********a@kia******.com',
          mobile: '93******82',
          skillset: 'L3',
          loginHourGoal: '08:00:00',
          actualLoginHour: '08:00:00',
          averageConversationsPerHour: 2,
          totalConversations: 18,
          totalConversationsResolved: 18,
          resolutionPercentage: '100.00%',
          averageHandleTimeSec: 1200,
          totalConversationsEscalated: 0,
          avgFirstResponseTimeSec: 25,
          totalHandleTimeHours: 6.0,
          totalHandleTimeMins: 360.0,
          avgResolutionTimeMins: 20.0,
          customerFeedbackRating: 4.4
        }
      ]
    }
  }
  const filteredData: any = () => {
    switch (selectedDate) {
      case 'Daily':
        return Data?.Daily || []
      case 'Weekly':
        return Data?.Weekly || []
      case 'Monthly':
        return Data?.Monthly || []
      case 'Quarterly':
        return Data?.Quarterly || []
      default:
        return []
    }
  }
  const projectData = [filteredData()][0]
  const filteredAgent = projectData.agentsListing.filter(
    (agent: any) => agent.agentId === String(uuid)
  )

  console.log(filteredAgent)

  const toNaviagte = () => {
    naviagte('/report/agent-dashboard')
  }

  return (
    <>
      <div
        id='kt_app_toolbar_container'
        className='app-container container-fluid d-flex flex-stack'
      >
        <div className='card-title col-4 align-items-start flex-row d-flex '>
          <span className='mt-1 text-hover-primary' onClick={toNaviagte}>
            <i className='bi bi-arrow-left' style={{ fontSize: '1.75rem' }}></i>
          </span>
          <h1
            className='page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0'
            style={{ marginLeft: '10px' }}
          >
            Agent Dashboard
          </h1>
        </div>
        <div className='d-flex align-items-center gap-2 gap-lg-3'>
          <div>
            <label>Date:</label>
            <select
              className='form-select  form-select '
              name='industryType'
              value={selectedDate}
              onChange={handleChange}
              style={{ width: '200px' }}
            >
              <option hidden>Select</option>
              <option value='Daily'>Daily</option>
              <option value='Weekly'>Weekly</option>
              <option value='Monthly'>Monthly</option>
              <option value='Quarterly'>Quarterly</option>
            </select>
          </div>
        </div>
      </div>
      <div className='row g-4 mb-4' style={{ marginTop: '20px' }}>
        <TaskCard agentValue={filteredAgent} />
      </div>
      <div className='row g-5 g-xl-8'>
        {/* <div className='col-xl-3 col-lg-6 col-md-6 col-xm-12'>
          <AgentActivity agentValue={agentDataValue[selectedDate]} title='Resolution Rate' />
        </div>
        <div className='col-xl-3 col-lg-6 col-md-6 col-xm-12'>
          <AgentActivity agentValue={agentDataValue[selectedDate]} title='Escalation Rate' />
        </div> */}
        <div className='col-xl-4 col-lg-6 col-md-6 col-xm-12'>
          <PieChartAgent chatStatus={filteredAgent} />
        </div>
        <div className='col-xl-4 col-lg-6 col-md-6 col-xm-12'>
          <SpeedMeter agentValue={filteredAgent} />
        </div>

        <div className='col-xl-4 col-lg-6 col-md-6 col-xm-12'>
          <AgentProfile agentValue={filteredAgent} profile={''} />
        </div>
      </div>

      <div className='row g-4 mb-4'>
        <div className='col-xl-6 col-lg-6 col-md-6 col-xm-12'>
          <AgentActivity agentValue={filteredAgent} title='Overall Performance' />
        </div>
        <div className='col-xl-2 col-lg-6 col-md-6 col-xm-12'>
          <ResponseCard
            title='Average First Response Time'
            value={filteredAgent[0]?.avgFirstResponseTimeSec + 'S'}
            svgLines={[
              { x1: 10, y1: 110, x2: 110, y2: 10, stroke: 'blue', strokeWidth: 2 },
              { x1: 110, y1: 10, x2: 210, y2: 110, stroke: 'green', strokeWidth: 2 },
              { x1: 210, y1: 110, x2: 310, y2: 10, stroke: 'red', strokeWidth: 2 },
              { x1: 310, y1: 10, x2: 410, y2: 110, stroke: 'purple', strokeWidth: 2 }
            ]}
            gradient='linear-gradient(to top, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0))'
          />
        </div>

        <div className='col-xl-2 col-lg-6 col-md-6 col-xm-12'>
          <ResponseCard
            title='Average Resolution Time'
            value={
              filteredAgent[0]
                ? filteredAgent[0].avgResolutionTimeMins.toString().replace('.', ':') + 'M'
                : ''
            }
            svgLines={[
              { x1: 20, y1: 100, x2: 120, y2: 20, stroke: 'orange', strokeWidth: 2 },
              { x1: 120, y1: 20, x2: 220, y2: 100, stroke: 'yellow', strokeWidth: 2 },
              { x1: 220, y1: 100, x2: 320, y2: 20, stroke: 'pink', strokeWidth: 2 },
              { x1: 320, y1: 20, x2: 420, y2: 100, stroke: 'cyan', strokeWidth: 2 }
            ]}
            gradient='linear-gradient(to top, rgba(255, 0, 0, 0.2), rgba(255, 0, 0, 0))'
          />
        </div>
        <div className='col-xl-2 col-lg-6 col-md-6 col-xm-12'>
          <ResponseCard
            title='Average Handle Time'
            value={
              filteredAgent[0]
                ? (filteredAgent[0].averageHandleTimeSec / 60).toFixed(2).replace('.', ':') + 'M'
                : ''
            }
            svgLines={[
              { x1: 30, y1: 90, x2: 130, y2: 30, stroke: 'black', strokeWidth: 2 },
              { x1: 130, y1: 30, x2: 230, y2: 90, stroke: 'gray', strokeWidth: 2 },
              { x1: 230, y1: 90, x2: 330, y2: 30, stroke: 'brown', strokeWidth: 2 },
              { x1: 330, y1: 30, x2: 430, y2: 90, stroke: 'maroon', strokeWidth: 2 }
            ]}
            gradient='linear-gradient(to top, rgba(0, 255, 0, 0.2), rgba(0, 255, 0, 0))'
          />
        </div>
      </div>
    </>
  )
}

export default DashboardIndex
